import { Component } from "@angular/core";
import { Platform, NavParams, ViewController } from "ionic-angular";
import { SummaryServiceProvider } from "../../../../providers/wh/summary-service";

@Component({
  selector: "select-area-modal",
  templateUrl: "select-area-modal.html",
  providers: [SummaryServiceProvider]
})
export class SelectAreaModalComponent {
  data;
  myInput: "";
  filterData = [];
  selectedItem = {};

  constructor(
    public platform: Platform,
    public params: NavParams,
    public summaryService: SummaryServiceProvider,
    public viewCtrl: ViewController
  ) {
    //this.filterData = JSON.parse(localStorage.getItem("fuFilters")).areaEntity;
    this.data = this.params.get("data");
  }

  viewArea() {
    this.filterData = JSON.parse(localStorage.getItem("fuFilters")).areaEntity;
    this.selectedItem = {};
    if (this.myInput) {
      let regex = new RegExp(this.myInput, "i");
      let searchResults = this.filterData.filter(ele => ele.value.match(regex));
      this.filterData = searchResults;
    }
  }

  saveArea() {
    let areaDataList = JSON.parse(localStorage.getItem("fuFilters")).areaEntity;
    let selectedAreaObj = areaDataList.filter(
      ele => ele.id == this.selectedItem
    )[0];
    selectedAreaObj.ids = selectedAreaObj.id;
    selectedAreaObj.name = selectedAreaObj.value;
    selectedAreaObj.driverEntity = this.data.driverEntity;
    selectedAreaObj.city = this.data.city;
    this.viewCtrl.dismiss(selectedAreaObj);
  }

  dismiss() {
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/collecion-points/select-area-modal/select-area-modal.ts